import React from 'react';
import { usuariosAPI } from '../../utils/funcionesAPI'
import { manejadorDeRespuesta } from '../../utils/Tools'
import { Link } from 'react-router-dom'

class Activacion extends React.Component {
  constructor(props) {
      super(props)
      this.state = {mensaje : ''};
    }


    componentDidMount() {

        const data = JSON.stringify({accion: 'activacion', codigo: this.props.match.params.codigoActivacion});
        usuariosAPI(data)
          .then(respuesta => {
              if (manejadorDeRespuesta(this.props, respuesta))
                  this.setState({mensaje: respuesta.data});
          });

    }


render() {
      return (
        <section className="sobre-pedraza">

          <div className="container">
            <div className="row">
              <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h1>Activaci&oacute;n finalizada</h1>
                <hr />

                <p>Por favor complet&aacute; tus datos personales antes de realizar una reserva desde la secci&oacute;n
                   <Link to='/mi-perfil'> Mi Perfil</Link></p>
              </article>
            </div>
          </div>
        </section>
      );
    }
}

export default Activacion;



// WEBPACK FOOTER //
// ./src/components/Registrar/Activacion.js